import { getShortUrl } from '@yandex-int/k-common/client/api';
import { Link as LinkIcon } from 'education-icons';
import { Button, Link, SimpleText, useMe, showIntlMessageNotification } from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/constants';
import { copyTextToClipboard } from 'platform-components/utils';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';
import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { useLessonViewParams } from 'common.components/lesson-view.index/hooks/use-lesson-view-params';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { useTeamRegistrationLink } from 'common.components/user/hooks/useTeamRegistrationLink';

import * as selectors from '../selectors';
import { SidePanelControlTypeProps } from '../typings';

interface Props extends SidePanelControlTypeProps {
    isMobile: boolean;
}

export const SidePanelControlsTypeCopyLessonLink = React.memo((props: Props) => {
    const { isMobile, notifyCanBeRender, notifyCanNotBeRender } = props;
    const dispatch = useDispatch();
    const { classId, subject } = useLessonViewParams();
    const canCopyLessonLink = useSelector((store) =>
        selectors.getShouldShowCopyLessonLink(store, { classId, subject, isMobile })
    );
    const me = useMe();
    const courseId = useSelector(getCurrentYearCourseId);
    const cLessonId = useSelector(lessonSelectors.getCLessonId);
    const link = useTeamRegistrationLink();
    const linkWithQuery = `${link}?course=${courseId}&lesson=${cLessonId}`;
    const shortLink = useRef<string | null>(null);

    const handleMouseOver = async () => {
        if (!shortLink.current) {
            shortLink.current = await getShortUrl(linkWithQuery);
        }
    };

    const copyLessonLink = () => {
        copyTextToClipboard(shortLink.current || linkWithQuery);

        dispatch(
            showIntlMessageNotification({
                closeDelay: COMMON_NOTIFICATION_DELAY,
                gravity: GRAVITIES.BOTTOM,
                messageId: 'toast.lesson.lessonLinkIsCopied',
                theme: NOTIFICATION_THEMES.TOAST,
                mix: 'lession-view__copy-lesson-link-toast',
            })
        );

        ym('reachGoal', 'teacher_copy_lesson_link', {
            user_id: me?.id,
            clesson_id: cLessonId,
            from: 'lesson_statistics_menu',
        });
    };

    if (!canCopyLessonLink) {
        notifyCanNotBeRender();
        return null;
    }

    notifyCanBeRender();

    return (
        <Link mix="qa_copy-lesson-link" onClick={copyLessonLink} onMouseEnter={handleMouseOver} pseudo>
            <Button accent={Button.ACCENT.NORMAL} icon={<LinkIcon />} view={Button.VIEW.CLEAR}>
                <SimpleText id="lessonModal.controls.copyLessonLink" />
            </Button>
        </Link>
    );
});
